
import lang from '../lang'
import { mapState } from 'vuex';
export default {
    data: function () {
        return {
            words: lang.LANG_WORDS
        }
    },
    computed: {
        ...mapState({
            user: state => state.apidata.user,
            set_lang: state => state.apidata.set_lang,
        }),
        app_lang_type: function (){
            console.log('com')
            if(this.set_lang){
                return this.set_lang;
            }
            else{
                return this.$store.state.auth.app_lang_type;
            }
        },
        mgw_phase_production_001: function(){
            if(process.env.NODE_ENV == 'production'){
                return true;
            }else{
                return false;
            }
        },
        vue_node_env: function(){
            return process.env.NODE_ENV;
        },
    },
    methods: {
        word_chg(value){
            // console.log('word_chg', value, this.words,  this.$store.state.auth.app_lang_type);
            if(this.words.some((word) => word.key == value)){
                // console.log('')
                const words = this.words.find((word) => word.key == value);
                const app_lang_type = this.app_lang_type;
                if(words && app_lang_type){
                    return words[app_lang_type];
                }
            }
            return value;
        },
        word_chg_html(value){
            if(this.words.some((word) => word.key == value)){
                // console.log('word_chg !!!', value, this.words);
                // console.log('')
                const words = this.words.find((word) => word.key == value);
                const app_lang_type = this.app_lang_type;
                const word = (words && app_lang_type)? words[app_lang_type]: '';
                const lang_html_key = (app_lang_type)? app_lang_type + '_html': 'html';
                if(words && words[lang_html_key]){
                    return words[lang_html_key].replace('%%', word);
                }
            }
            return value;
        }
    }
}
